// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import ConnectedEmailAccount from 'conversations-internal-schema/connected-email-account/records/ConnectedEmailAccount';
import indexBy from 'transmute/indexBy';
import map from 'transmute/map';
import pipe from 'transmute/pipe';
import { getIndexId } from './getIndexId';
export const indexConnectedAccounts = rawConnectedAccounts => pipe(indexBy(getIndexId), map(ConnectedEmailAccount))(rawConnectedAccounts);